<script setup>
import { onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';
import {
  useFunctionGetter,
  useStore,
  useStoreGetters,
} from 'dashboard/composables/store';
import {
  getUserRole,
  getUserPermissions,
} from 'dashboard/helper/permissionsHelper';

import WootReports from './components/WootReports.vue';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';

const route = useRoute();
const store = useStore();
const getters = useStoreGetters();
const agent = useFunctionGetter('agents/getAgentById', route.params.id);

const currentUser = computed(() => getters.getCurrentUser.value);
const currentAccountId = computed(() => getters.getCurrentAccountId.value);

const isCurrentUserAgent = computed(() => {
  if (!currentUser.value || !currentAccountId.value) return false;

  const role = getUserRole(currentUser.value, currentAccountId.value);
  const permissions = getUserPermissions(
    currentUser.value,
    currentAccountId.value
  );

  return role === 'agent' && !permissions.includes('access_all_reports');
});

onMounted(() => store.dispatch('agents/get'));
</script>

<template>
  <WootReports
    v-if="agent.id"
    :key="agent.id"
    type="agent"
    getter-key="agents/getAgents"
    action-key="agents/get"
    :selected-item="agent"
    :download-button-label="$t('AGENT_REPORTS.DOWNLOAD_AGENT_REPORTS')"
    :report-title="$t('AGENT_REPORTS.HEADER')"
    has-back-button
    :readonly-filter-dropdown="isCurrentUserAgent"
  />
  <div v-else class="w-full py-20">
    <Spinner class="mx-auto" />
  </div>
</template>
